import { baseURL } from '@functions/api'

type BuildProofSheetLinkParams = {
  campaignId: number,
  selectedEntityIds: number[],
}

const buildProofSheetLink = (params: BuildProofSheetLinkParams) => {
  const { campaignId, selectedEntityIds } = params

  if (selectedEntityIds?.length){
    let url = `${baseURL}/campaigns/${campaignId}/proof_sheet?`

    selectedEntityIds?.forEach((imageId, index) => {
      url += `image_ids[]=${imageId}`
      if (index !== selectedEntityIds.length - 1) url += '&'
    })

    return url
  }

  return ''
}

interface UseMediaReviewerParams {
  campaignId: number,
  selectedImageIds?: number[],
}
const useMediaReviewer = (params: UseMediaReviewerParams) => {
  const { campaignId, selectedImageIds } = params

  return {
    callbacks: {
      buildProofSheetLink: () => buildProofSheetLink({ campaignId, selectedEntityIds: selectedImageIds || [] }),
    },
  }
}

export default useMediaReviewer
